module.exports.DEFAULT_LANG = 'en'